import type { HTMLAttributes } from "react";

export type HistoryTier = "bust" | "low" | "mid" | "high";

export function historyTier(multiplier: number): HistoryTier {
  if (multiplier < 1.1) return "bust";
  if (multiplier < 2) return "low";
  if (multiplier < 10) return "mid";
  return "high";
}

export interface HistoryChipProps extends HTMLAttributes<HTMLSpanElement> {
  multiplier: number;
}

export function HistoryChip({ multiplier, className, ...rest }: HistoryChipProps) {
  const tier = historyTier(multiplier);
  const cls = ["vb-hist", `tier-${tier}`, className].filter(Boolean).join(" ");
  return (
    <span className={cls} {...rest}>
      {multiplier.toFixed(2)}×
    </span>
  );
}
